import { render, staticRenderFns } from "./goods-category.vue?vue&type=template&id=75d64bd3&"
import script from "./goods-category.vue?vue&type=script&lang=js&"
export * from "./goods-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports